var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",class:{ enabled: _vm.isEnabled },on:{"click":_vm.toggle}},[_c('div',{staticClass:"switch",attrs:{"role":"button","aria-label":"toggle setting"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }